var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-content"},[_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(_vm.beianNumber)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }